if (!customElements.get("td-variant-dropdown")) {
  class TdVariantDropdown extends HTMLElement {
    constructor() {
      super();
      this.toggleButton = null;
      this.list = null;
      this.isOpen = false;
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    connectedCallback() {
      this.toggleButton = this.querySelector('[data-dropdown-toggle]');
      this.list = this.querySelector('[data-dropdown-list]');
      this.items = Array.from(this.querySelectorAll('.td-variant-dropdown__item'));
      if (!this.toggleButton || !this.list) return;

      this.toggleButton.addEventListener('click', () => this.toggleDropdown());
      this.items.forEach(item => {
        item.addEventListener('click', (e) => this.selectItem(e, item));
      });
      this.addEventListener('keydown', this.handleKeyDown);
      this.setAria();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
      this.removeEventListener('keydown', this.handleKeyDown);
    }

    setAria() {
      this.toggleButton.setAttribute('aria-expanded', this.isOpen);
      this.list.setAttribute('aria-hidden', !this.isOpen);
    }

    toggleDropdown(forceState) {
      this.isOpen = typeof forceState === 'boolean' ? forceState : !this.isOpen;
      this.setAria();
      if (this.isOpen) {
        this.list.hidden = false;
        this.list.style.maxHeight = this.list.scrollHeight + 'px';
        this.toggleButton.querySelector('.td-variant-dropdown__arrow--down').style.display = 'none';
        this.toggleButton.querySelector('.td-variant-dropdown__arrow--up').style.display = '';
        document.addEventListener('click', this.handleDocumentClick);
        this.items[0].focus();
      } else {
        this.list.style.maxHeight = '0px';
        setTimeout(() => { this.list.hidden = true; }, 200);
        this.toggleButton.querySelector('.td-variant-dropdown__arrow--down').style.display = '';
        this.toggleButton.querySelector('.td-variant-dropdown__arrow--up').style.display = 'none';
        document.removeEventListener('click', this.handleDocumentClick);
      }
    }

    handleDocumentClick(e) {
      if (!this.contains(e.target)) {
        this.toggleDropdown(false);
      }
    }

    handleKeyDown(e) {
      if (!this.isOpen && (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        this.toggleDropdown(true);
        return;
      }
      if (!this.isOpen) return;
      const currentIndex = this.items.findIndex(item => item === document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const next = this.items[(currentIndex + 1) % this.items.length];
        next && next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = this.items[(currentIndex - 1 + this.items.length) % this.items.length];
        prev && prev.focus();
      } else if (e.key === 'Escape') {
        this.toggleDropdown(false);
        this.toggleButton.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        if (document.activeElement.classList.contains('td-variant-dropdown__item')) {
          document.activeElement.click();
        }
      }
    }

    selectItem(e, item) {
      e.preventDefault();
      // Remove selected class from all
      this.items.forEach(i => i.classList.remove('td-variant-dropdown__item--selected'));
      item.classList.add('td-variant-dropdown__item--selected');
      // Update toggle button text
      this.toggleButton.querySelector('.td-variant-dropdown__selected').textContent = item.textContent;
      // Set aria-selected
      this.items.forEach(i => i.setAttribute('aria-selected', 'false'));
      item.setAttribute('aria-selected', 'true');
      // Update the hidden select in the same wrapper
      const value = item.getAttribute('data-value');
      const select = this.querySelector('select');
      if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.toggleDropdown(false);
      this.toggleButton.focus();
    }
  }
  customElements.define("td-variant-dropdown", TdVariantDropdown);
} 